import { render, staticRenderFns } from "./VoicedAndDeafConsonantsForm.vue?vue&type=template&id=410b57a6&scoped=true&lang=pug&"
import script from "./VoicedAndDeafConsonantsForm.vue?vue&type=script&lang=js&"
export * from "./VoicedAndDeafConsonantsForm.vue?vue&type=script&lang=js&"
import style0 from "./VoicedAndDeafConsonantsForm.vue?vue&type=style&index=0&id=410b57a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b57a6",
  null
  
)

export default component.exports